import { WSButton, WSButtonProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { openIntercom, openIntercomMessage } from "../../shared/utils/intercom";
import { getFullStorySessionId } from "../../utils/fullStory";

type Props = WSButtonProps<"Link">;

export const ButtonContactSupport: React.FC<Props> = props => {
  const { children, ...buttonProps } = props;

  return (
    <WSButton.Link
      {...buttonProps}
      onClick={() => {
        const fsId = getFullStorySessionId();

        fsId
          ? openIntercomMessage(
              `Hi there! I just got an error #${fsId}. Could you help me with it?\n\n`
            )
          : openIntercom();
      }}
      type="button"
    >
      {children}
    </WSButton.Link>
  );
};
